import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Tabs,
  Tab,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
} from "@mui/material";
import api from "../../../services/api";

const LoyaltyCardByToken = () => {
  const { token } = useParams();
  const [customerData, setCustomerData] = useState(null);
  const [rewardOffers, setRewardOffers] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
    if (newIndex === 1 && rewardOffers.length === 0) {
      fetchRewardOffers();
    }
  };

  useEffect(() => {
    const fetchCustomerByToken = async () => {
      try {
        const res = await api.get(`/admin/digitalLoyalty/points/${token}`);
        setCustomerData(res.data);
      } catch (err) {
        setError("Unable to find your loyalty profile.");
      } finally {
        setLoading(false);
      }
    };

    fetchCustomerByToken();
  }, [token]);

  const fetchRewardOffers = async () => {
    try {
      const response = await api.get("/admin/rewards/offers");
      setRewardOffers(response.data);
    } catch (err) {
      console.error("Error fetching reward offers:", err);
    }
  };

  return (
    <Card sx={{ maxWidth: 800, margin: "auto", mt: 4, mb: 4, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h5" align="center" sx={{ mb: 2 }}>
          My Loyalty Points
        </Typography>

        {loading ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error" align="center">
            {error}
          </Typography>
        ) : (
          <>
            <Typography variant="h4" align="center" sx={{ mb: 2 }}>
              Points: {customerData.points}
            </Typography>

            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              centered
              sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tab label="History" />
              <Tab label="Rewards" />
            </Tabs>

            <Box sx={{ p: 2 }}>
              {tabIndex === 0 && (
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Type</TableCell>
                        <TableCell>Points</TableCell>
                        <TableCell>Reason</TableCell>
                        <TableCell>Date</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {customerData.pointsActivity.map((activity, index) => (
                        <TableRow key={index}>
                          <TableCell>{activity.type}</TableCell>
                          <TableCell>{activity.points}</TableCell>
                          <TableCell>{activity.reason}</TableCell>
                          <TableCell>
                            {new Date(activity.timestamp).toLocaleDateString()}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              {tabIndex === 1 && (
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Reward</TableCell>
                        <TableCell>Points Required</TableCell>
                        <TableCell>Status</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rewardOffers.map((offer, index) => (
                        <TableRow key={index}>
                          <TableCell>{offer.name}</TableCell>
                          <TableCell>{offer.pointsRequired}</TableCell>
                          <TableCell>
                            {customerData.points >= offer.pointsRequired
                              ? "Target Reached"
                              : "Not Enough Points"}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Box>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default LoyaltyCardByToken;
